const addLeadingZero = (number) => (number > 9 ? number : `0${number}`)

export {addLeadingZero}